// @ts-nocheck
export enum StatusCode {
  Success = 1,
  BadResult = -1,
}
